import { render, staticRenderFns } from "./messengerTasks.vue?vue&type=template&id=995508ac&"
import script from "./messengerTasks.vue?vue&type=script&lang=js&"
export * from "./messengerTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports